import { Check, Sparkles } from "lucide-react";
import { IMAGES } from "../data";
import { Reveal } from "./Reveal";

const FEATURES = [
  "Premium Ambience",
  "Comfortable Stay",
  "Event-Friendly Venue",
  "Convenient Location",
  "Warm Hospitality",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-white py-16 sm:py-20 lg:py-28">
    <div className="section-wrap grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <Reveal className="relative">
        <div className="border border-gold/30 p-3">
          <img
            src={IMAGES.about}
            alt="Elegant interior of Kasdol Hotel property"
            loading="lazy"
            className="h-80 w-full object-cover sm:h-[28rem]"
          />
        </div>
        <div
          data-testid="about-experience-badge"
          className="absolute -bottom-6 left-4 right-4 flex items-center gap-4 rounded-sm bg-navy p-5 shadow-2xl sm:left-auto sm:-right-2 sm:w-72"
        >
          <Sparkles className="h-9 w-9 shrink-0 text-gold" />
          <div>
            <p className="font-serif text-xl font-bold text-cream">500+ Celebrations</p>
            <p className="text-xs text-cream/70">Hosted with warmth, care and attention to detail</p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={150} className="pt-6 lg:pt-0">
        <p className="eyebrow">About Kasdol Hotel</p>
        <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl lg:text-5xl">
          One Destination. Every Celebration.
        </h2>
        <p className="mt-6 text-base leading-relaxed text-ink/75">
          Kasdol Hotel brings together elegant celebrations, comfortable accommodation and enjoyable dining
          under one roof. Whether you are planning a wedding, hosting a special event, staying overnight or
          enjoying a meal with family, our property is designed to make every visit comfortable and memorable.
        </p>

        <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {FEATURES.map((f) => (
            <li key={f} className="flex items-center gap-2.5 text-sm font-medium text-ink/80">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10">
                <Check className="h-3.5 w-3.5 text-gold" />
              </span>
              {f}
            </li>
          ))}
        </ul>

        <a href="#gallery" data-testid="about-discover-cta" className="btn-gold mt-10">
          Discover Kasdol Hotel
        </a>
      </Reveal>
    </div>
  </section>
);
